// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gwzQEzOqQU9TKoiAcPFH{width:100%;height:100%;min-height:calc(100vh - 90px);display:flex;justify-content:center;align-items:center}`, "",{"version":3,"sources":["webpack://./src/pages/SignUpPage/SignUpPage.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA,CACA,WAAA,CACA,6BAAA,CACA,YAAA,CACA,sBAAA,CACA,kBAAA","sourcesContent":[".wrapper {\n  width: 100%;\n  height: 100%;\n  min-height: calc(100vh - 90px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `gwzQEzOqQU9TKoiAcPFH`
};
export default ___CSS_LOADER_EXPORT___;
